export enum ACTIVATE_LOCALSTORAGE_KEYS {
    LOCAL_LOGO_KEY = 'secondScreenAuthManagerLogo',
    LOCAL_MVPD_KEY = 'secondScreenAuthManagerMvpdCode',
    LOCAL_ORIGINATING_CLIENTID_KEY = 'secondScreenAuthManagerOriginatingClientId',
    LOCAL_PLATFORMCODE_KEY = 'secondScreenAuthManagerPlatformCode',
    LOCAL_ACTIVATION_CODE = 'secondScreenAuthManagerActivationCode',
}

export const ACTIVATION_CODE = 'activationCode';
export const AUTH_CODE = 'authorizationCode';
